// import React, { useState, useEffect } from "react";
// import LazyLoad from "react-lazyload";
// import { webPath } from "../apiConfig";

// const AdCarousel = ({ ads = [], className,timer }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [fade, setFade] = useState(true);
//   const currentAd = ads[currentIndex];

// useEffect(() => {
//     const timeout = setTimeout(() => {
//       setFade(false);

//       setTimeout(() => {
//         setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
//         setFade(true);
//       }, 200); // allow fade-out before switching
//     }, (currentAd?.duration_time || 5) * 1000); // default to 5s

//     return () => clearTimeout(timeout);
//   }, [currentIndex, ads]);


//     useEffect(() => {
//     const nextIndex = (currentIndex + 1) % ads.length;
//     const nextImg = new Image();
//     nextImg.src = `${webPath}${ads[nextIndex]?.banner_img}?width=400`;
//   }, [currentIndex, ads]);
//   return (
//     // <div className="marTop sticky-top" style={{ height: "auto" }}>
//     //   {/* Inline animation styles */}
//     //   <style>
//     //     {`
//     //       .ad-image {
//     //         opacity: 0;
//     //         transition: opacity 0.8s ease-in-out;
//     //       }
//     //       .ad-image.fade-in {
//     //         opacity: 1;
//     //       }
//     //     `}
//     //   </style>

//     //   <LazyLoad className={className}>
//     //     {currentAd && (
//     //       <a
//     //         href={currentAd?.dest_url}
//     //         target="_blank"
//     //         rel="noopener noreferrer"
//     //       >
//     //         <img
//     //           src={`${webPath}${currentAd?.banner_img}?width=400`}
//     //           alt={currentAd?.banner_name}
//     //           className={`ad-image ${fade ? "fade-in" : ""}`}
//     //           style={{ width: "100%", height: "auto" }}
//     //         />
//     //       </a>
//     //     )}
//     //   </LazyLoad>
//     // </div>

//     <div>dfdfdf</div>
//   );
// };

// export default AdCarousel;


import React, { useState, useEffect } from "react";
import LazyLoad from "react-lazyload";
import { API_ROOT, webPath } from "../apiConfig";
import { getAdImageUrl } from "./getAdImageUrl";

const AdCarousel = ({ ads = [], className, timer }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [showAd, setShowAd] = useState(false);

  const currentAd = ads[currentIndex];

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];

    const lastVisitDate = localStorage.getItem("adVisitDate");
    let visitCount = parseInt(
      localStorage.getItem("adVisitCount") || "0",
      10
    );

    // New day -> reset count
    if (lastVisitDate !== today) {
      visitCount = 0;
      localStorage.setItem("adVisitDate", today);
      localStorage.setItem("adVisitCount", "0");
    }

    // -----------------------------------------
    // COUNT ONLY ONCE PER BROWSER SESSION
    // -----------------------------------------

    const alreadyCountedThisSession =
      sessionStorage.getItem("adVisitCounted");

    if (!alreadyCountedThisSession) {
      visitCount += 1;

      localStorage.setItem("adVisitCount", visitCount.toString());

      sessionStorage.setItem("adVisitCounted", "true");
    }

    // -----------------------------------------
    // SHOW ONLY FIRST 3 VISITS
    // -----------------------------------------

    if (visitCount <= 3) {
      setShowAd(true);
    } else {
      setShowAd(false);
    }
  }, []);

  // -----------------------------------------
  // AD CAROUSEL
  // -----------------------------------------

  useEffect(() => {
    if (!showAd || !ads.length || !currentAd) {
      return;
    }

    const timeout = setTimeout(() => {
      setFade(false);

      setTimeout(() => {
        setCurrentIndex(
          (prevIndex) => (prevIndex + 1) % ads.length
        );

        setFade(true);
      }, 200);
    }, (currentAd?.duration_time || 5) * 1000);

    return () => clearTimeout(timeout);
  }, [currentIndex, ads, showAd, currentAd]);

  // -----------------------------------------
  // PRELOAD NEXT IMAGE
  // -----------------------------------------

  useEffect(() => {
    if (!showAd || !ads.length) {
      return;
    }

    const nextIndex = (currentIndex + 1) % ads.length;
    const nextImg = new Image();
    if (ads[nextIndex]?.banner_img) {
      nextImg.src = `${webPath}${ads[nextIndex].banner_img}`;
    }
  }, [currentIndex, ads, showAd]);

  // -----------------------------------------
  // DON'T RENDER AFTER 3 VISITS
  // -----------------------------------------

  if (!showAd) {
    return null;
  }

  if (!currentAd) {
    return null;
  }

  return (
    <div className="marTop">
      <LazyLoad className={className}>
        <a
          href={currentAd.dest_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${webPath}${currentAd.banner_img}`}
            alt={currentAd.banner_name}
            className={`ad-image ${fade ? "fade-in" : ""}`}
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        </a>
      </LazyLoad>
    </div>
  );
};

export default AdCarousel;